// TODO: Once design spec defined for default empty message. Till then simple <p> as default